/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/home/HeroSection';
import PlatformSection from '../components/home/PlatformSection';
import FeaturesSection from '../components/home/FeaturesSection';
import UseCasesSection from '../components/home/UseCasesSection';
import StandardizeSection from '../components/home/StandardizeSection';
import RoadmapSection from '../components/home/RoadmapSection';
import ContactSection from '../components/home/ContactSection';
import DynamicHomePage from './DynamicHomePage';
import { usePublicIndex } from '../hooks/usePublicIndex';
import '../styles/Home.css';

function DefaultHome() {
  return (
    <>
      <Header />
      <HeroSection />
      <PlatformSection />
      <FeaturesSection />
      <UseCasesSection />
      <StandardizeSection />
      <RoadmapSection />
      <ContactSection />
      <Footer />
    </>
  );
}

function Home() {
  const { data, isLoading } = usePublicIndex();
  const homepageType = data?.app_branding?.homepage_type;

  // Show a neutral spinner while data loads — never flash DefaultHome
  // content (hero "Welcome to Our Platform" etc.) when custom mode is active.
  if (isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="spinner-border text-secondary" />
      </div>
    );
  }

  if (homepageType === 'custom') {
    return <DynamicHomePage />;
  }

  return <DefaultHome />;
}

export default Home;
